import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import GlobalStyles from '@mui/material/GlobalStyles';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { useFormik } from 'formik';
import { styled} from '@mui/material/styles';
import { useNavigate, useLocation} from 'react-router-dom'
import JoinusValidation from '../../../validation/joinusValidation'
import Checkbox from '@mui/material/Checkbox';
import firebase, {auth} from '../../../firebase/firebase'
import {useContext} from "react";
import {AuthUserContext} from "../../../providers/AuthProvider";
import {useIntl} from 'react-intl'
import Stepper from "../../../components/stepper";
import Avatar from "@mui/material/Avatar/Avatar";
import Link from "@mui/material/Link/Link";
import CircularProgress from "@mui/material/CircularProgress/CircularProgress";
import IconButton from "@mui/material/IconButton/IconButton";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DialogActions from "@mui/material/DialogActions/DialogActions";
import ScrollToTop from '../../../utils/scrollTop';
import { FormControl, InputAdornment, InputLabel, OutlinedInput } from '@mui/material';
import tooltipClasses from '@mui/material/Tooltip';
import Tooltip from '@mui/material/Tooltip';
import { HelpOutlineOutlined } from '@mui/icons-material';

export default function JoinUs(){
  const storageRef = firebase.storage().ref();

  const [loading, setLoading] = React.useState(false)
  const Input = styled('input')({
    display: 'none',
  })

  const [profileImage, setProfileImage] = React.useState();

  const { user, setUser, profile, setProfile } = useContext(AuthUserContext);
  const [showPass, setShowPass] = React.useState(false)
  const navigator = useNavigate();
  const location= useLocation();
  const {messages} = useIntl();

 const joinusSchema = JoinusValidation.joinusSchema
  if (location.state.selected !== 'creator') {
    delete joinusSchema.fields.role;
  }
  const formik = useFormik({
    initialValues: JoinusValidation.initialValues,
    validationSchema: joinusSchema,
    onSubmit: async (values) => {
      const { email,
        password,
        name,
        role = values?.role || '',
        age18 = false
      } = values;

      try {

        const isEmailExists = await auth.fetchSignInMethodsForEmail(email)



         
        if(isEmailExists && isEmailExists.length === 0) {

          if (location.state.selected === 'creator') {
            navigator('/auth/additional-details', {state: {selected: location.state.selected, data: {  email,
                  avatar: profileImage && profileImage?.path ? profileImage?.path : null,
                  name,
                  userType: location.state.selected,
                  role,
                  password
                }}});

          } else {
            navigator('/auth/additional-details', {state: {selected: location.state.selected, data: {  email,
                  avatar: profileImage && profileImage?.path ? profileImage?.path : null,
                  name,
                  userType: location.state.selected,
                  password
                }}});
            // navigator('/investor/membership-plan')

          }
        } else {
          formik.setFieldError('email', 'Your email address is already exists.')
        }
      } catch (e) {
        setLoading(false)
        alert(JSON.stringify(e, null, 2));
      }
    },
  });

  const handleClickShowPassword = () => {
    setShowPass(!showPass)
  };


  const uploadFile = () => {

    setLoading(true)

    const file = profileImage?.file
    const path = `profile-image/${file.name}`
    const uploadTask = storageRef.child(path).put(file);

    uploadTask.on('state_changed',
        (snapshot) => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log('Upload is ' + progress + '% done');
          const image = {...profileImage, progress}
          setProfileImage(image)
          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED: // or 'paused'
              console.log('Upload is paused');
              break;
            case firebase.storage.TaskState.RUNNING: // or 'running'
              console.log('Upload is running');
              break;
          }
        },
        (error) => {
          setLoading(false)

        },
        () => {
          setLoading(false)

          setProfileImage({...profileImage,path, progress:100})
        }
    );

  }
  return(
      <>
       <ScrollToTop/>
        <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />
        {/* Hero unit */}
        {/*<TopBar/>*/}
        {/* <Container  maxWidth="lg" component="main" sx={{ pt: 4, }}>
        <Typography variant="h3" align="center" color="text.primary" component="p">
          Logo
        </Typography>
      </Container>*/}
        <Stepper stepNumber={2}/>

        <Container  maxWidth="md" component="main" sx={{}}>
          <Box sx={{pl: 10, pr: 10 }}>
            <Typography variant="h4" align="left" color="text.primary" component="p">
              Personal details
              {/*{messages?.joinNow?.create_new_account?.pageTitle}*/}
            </Typography>
            <Typography variant="body" align="left" color="text.primary" component="p" sx={{ margin: '20px 0px 40px 0px', }}>
              {messages?.joinNow?.create_new_account?.titleA}<br/>{messages?.joinNow?.create_new_account?.titleB}<Button variant="text" sx={{textDecoration: 'underline', fontWeight: 600, top: -2}} onClick={()=>navigator('/auth/login')}>{messages?.joinNow?.create_new_account?.signinButton}</Button>
            </Typography>
          </Box>

        </Container>
        {/* End hero unit */}
        <Container maxWidth="md" component="main" sx={{}}>

          <Stack direction="column"
                 justifyContent="center"
                 alignItems="center"
                 spacing={2} sx={{mb: 5}}>
            <label htmlFor="profile-image">
              <Avatar alt={'Tabain'}  src={profileImage && profileImage?.src ? profileImage?.src :'/assets/default-avatar.png'} sx={{width: 220, height: 220, cursor: 'pointer' }} component={'span'} />
              <Input accept="image/*" id="profile-image" multiple={false} type="file" onChange={(e)=>{
                const fileReader = new FileReader();
                fileReader.readAsDataURL(e.target.files[0]);
                fileReader.addEventListener("load", async function () {
                  setProfileImage({
                    progress:0,
                    src: this.result,
                    file: e.target.files[0],
                    size:  (e.target.files[0]?.size / 1024 / 1024).toFixed(2)


                  });
                });
              }} />

            </label>
            <Button variant={'outlined'}  sx={{paddingX: 4}} component="span" onClick={uploadFile} disabled={!profileImage}>Upload {profileImage?.progress === 100 && <CheckCircleIcon style={{marginLeft: '15px'}}/>} {loading && <CircularProgress sx={{ml: 2}} size={20} color="primary"/>}</Button>
            {profileImage && profileImage?.src && <Link onClick={() => setProfileImage(undefined)}>Remove picture</Link>}
          </Stack>

          <Grid container spacing={2}  sx={{pl: 10, pr: 10}}>

            <Grid item xs={12}>
              <Box   component="form" onSubmit={formik.handleSubmit} sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                mb: 2,
                flexDirection:'column',
              }}
              >
                <Grid container spacing={2}>


                  <Grid item xs={12}>
                    <TextField
                        value={formik.values.name}
                        onChange={formik.handleChange}
                        error={formik.touched.name && Boolean(formik.errors.name)}
                        helperText={formik.touched.name && formik.errors.name}
                        label={messages?.joinNow?.create_new_account?.form?.name} name="name" variant="outlined" sx={{width:'100%'}} />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                        name="email"
                        label={ messages?.joinNow?.create_new_account?.form?.email}
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        error={formik.touched.email && Boolean(formik.errors.email)}
                        helperText={formik.touched.email && formik.errors.email}
                        variant="outlined" sx={{width:'100%'}} type="email"/>
                  </Grid>

                  <Grid item xs={12}>
                  <FormControl sx={{ width: '100%'}} variant="outlined" >
                      <InputLabel htmlFor="outlined-adornment-password" sx={{display:"flex", flexDirection:"row"}}><Typography sx={{color: formik.touched.password && Boolean(formik.errors.password) && "#d32f2f"}}>Password</Typography>
                      <Tooltip
                      componentsProps={{
                        tooltip: {
                          sx: {
                            maxWidth: "150px",
                            bgcolor: '#204488',
                            '& .MuiTooltip-arrow': {
                              color: '#204488',
                            },
                          },
                        },
                      }}
                      title={<>Password must have : <br/> 1 Uppercase <br/>1 Lowercase <br/>1 Number <br/>1 Special character <br/>8 Characters</>} arrow sx={{width:"100px"}} placement="bottom-start">
                          <HelpOutlineOutlined sx={{borderRadius:"100%", ml:1, fontSize:"24px"}}/>
                        </Tooltip>
                      </InputLabel>
                      <OutlinedInput
                        value={formik.values.password}
                        onChange={formik.handleChange}
                        error={formik.touched.password && Boolean(formik.errors.password)}
                        helperText={formik.touched.password && formik.errors.password}
                        type={showPass ? 'text' : 'password'}
                        name="password"
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              edge="end"
                              >
                              {!showPass ? <img src="/assets/eye_close.png" alt=""/> : <img src="/assets/eye_open.png" alt=""/>}
                            </IconButton>
                          </InputAdornment>
                        }
                        label="newpassword"

                        />
                         <Typography zIndex='tooltip' align='left' sx={{color:"#d32f2f", ml:"14px", mt:"3px", fontSize:"0.75rem"}}>{formik.touched.password && formik.errors.password}</Typography>
                    </FormControl>
                  </Grid>



                  {location?.state?.selected === 'creator'
                      &&
                      <Grid item xs={12}>

                        <TextField
                            select
                            value={formik.values.role}
                            onChange={formik.handleChange}
                            error={formik.touched.role && Boolean(formik.errors.role)}
                            helperText={formik.touched.role && formik.errors.role}
                            name='role'
                            label={messages?.joinNow?.create_new_account?.form?.role} variant="outlined" sx={{width:'100%',  textAlign: 'left'}}>
                          <MenuItem value={'Producer'}>Producer</MenuItem>
                          <MenuItem value={'Director'}>Director</MenuItem>
                        </TextField>

                      </Grid>
                  }
                  <Grid  xs={12}  container
                         direction="row"
                         justifyContent="flex-start"
                         alignItems="center" sx={{py: 2, px: .5}}>
                    <Checkbox
                        name="age18"
                        checked={formik.values.age18}
                        onChange={formik.handleChange}
                        inputProps={{ 'aria-label': 'controlled' }}

                    />
                    I confirm that I am 18 years old or over.
                    {formik.touched.age18 && formik.errors.age18}
                  </Grid>
                  <Grid item xs={12}>
                    <div style={{width:'100%', margin: 'auto'}}>

                      <Typography variant="body" align="left" color="text.primary" component="p" sx={{ margin: '20px 0px'}}>
                        {messages?.joinNow?.create_new_account?.lastText}
                        
                        <Button variant="text" sx={{textDecoration: 'underline', fontWeight: 600, top: -2,textTransform:"none"}}onClick={()=>navigator('/terms')}>{messages?.joinNow?.create_new_account?.termsOfService}</Button>
                      </Typography>
                    </div>
                  </Grid>
                  <Container  maxWidth="lg"  component="main" sx={{  }}>

                    <Stack spacing={5} direction="row" sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginTop:"20px",
                      marginBottom:"20px"
                    }}>
                      <Button variant="outlined" sx={{pt: 1, pb:1, pl: 5, pr:5, textTransform:'capitalize',width:"180px"}}   onClick={() => navigator(-1)}>Go back</Button>

                      <Button variant="contained" sx={{pt: 1.2, pb:1.2, pl: 5, pr:5, textTransform:'capitalize',width:"180px"}}  type='submit'  >{messages?.joinNow?.create_new_account?.nextButton}</Button>
                    </Stack>
                  </Container>
                  <Container  maxWidth="lg"  component="main" sx={{ mt: '35px', mb: '20px'}}>
                    <div style={{backgroundColor: '#000', width: '100%', height:1,} }/>
                    <div style={{width: '75px', margin: 'auto', top: '-13px', position: 'relative'}}>
                      <Typography sx={{backgroundColor: '#fff',textAlign:"center" }}>
                        {messages?.joinNow?.create_new_account?.OR}
                      </Typography>
                    </div>
                  </Container>
                 
									<Container  maxWidth="lg"  component="main" sx={{  }}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={4}>
                    <Button  variant="outlined" sx={{width: '100%', pt: 1.2, pb:1.2, pl: 5, pr:5, color: "#a0a0a0"  }} startIcon={<img src="/assets/imdb.png" style={{height: 25 ,  color: "#a0a0a0"}} alt="imdb "/>} disabled={true}>
                                            IMDb
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} md={4}>

                                            <Button  variant="outlined" sx={{width: '100%', pt: 1.2, pb:1.2, pl: 5, pr:5, color: "#a0a0a0" }} startIcon={<img src="/assets/Twitter.png" style={{height: 25 }} alt="twitter "/>} disabled={true}>
                                                Twitter
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Button  variant="outlined" sx={{width: '100%', pt: 1.2, pb:1.2, pl: 5, pr:5, color: "#a0a0a0" }} startIcon={<img src="/assets/Linkedin.png" style={{height: 25 }} alt="linkedin"/>} disabled={true}>
                                                Linkedin
                                            </Button>
                    </Grid>

                  </Grid>
                </Container>



                </Grid>

              </Box>
            </Grid>
            {/*<Grid item xs={4}>
            <Box sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              mb: 2,
              height:  200,
              flexDirection:'column'
            }}
            >
              <Button variant="contained" sx={{pt: 1.2, pb:1.2, marginBottom: '10px', width:'100%', fontSize: 'larger'}} >Linkedin</Button>
              <Button variant="contained" sx={{pt: 1.2, pb:1.2, marginBottom: '10px', width:'100%', fontSize: 'larger'}} >Twitter</Button>
              <Button variant="contained" sx={{pt: 1.2, pb:1.2, marginBottom: '10px', width:'100%', fontSize: 'larger'}} >Google</Button>
            </Box>
          </Grid>*/}
          </Grid>
        </Container>



      </>
  )
}